import Big from 'big.js'

const lookupCurrencyUnitFormat = (value: Big): { value: string, symbol: string } | undefined => {
  const units = [
    // { value: '1.0e+12', symbol: 'T' },
    { value: '1.0e+9', symbol: 'B' },
    { value: '1.0e+6', symbol: 'M' }
  ]

  return units.find((unit) => {
    return value.gte(new Big(unit.value))
  })
}

export const stringToCurrencyFormat = (value: string, unitFormatEnabled = false): string => {
  const numberString = value.replace(/\D/g, '')
  const minus = value.startsWith('-') ? '-' : ''

  if (numberString === '') {
    return `${minus}`
  }

  const numberStringWithoutMinus = value.replace(/-/g, '')

  const bigValue = new Big(numberStringWithoutMinus)

  if (unitFormatEnabled) {
    const unit = lookupCurrencyUnitFormat(bigValue)
    if (unit !== undefined) {
      const resultWith2Decimal = bigValue.div(new Big(unit.value)).toFixed(2, Big.roundDown)
      return `${minus}${new Big(resultWith2Decimal).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${unit.symbol}`
    }
  }

  return `${minus}${bigValue.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}

export const stringToNumberString = (value: string): string => {
  const numberString = value.replace(/\D/g, '')
  const minus = value.startsWith('-') ? '-' : ''

  return `${minus}${numberString}`
}
